/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import conceptsRegistry from './ConceptsRegistry'
import ConceptsUtil from './util/ConceptsUtil'

define([], function () {
	'use strict'

	class OntologyService {

		initialize(glassContext) {
			return Promise.resolve().then(this._glassContext = glassContext);
		}

		/**
		 * return the registered concept for this IRI
		 * @param iri the IRI of the concept
		 * @return the found concept, can be undefined
		 */
		getConcept(iri) {
			return conceptsRegistry.getConcept(iri)
		}

		/**
		 * return the registered concept for each IRI
		 * @param iris the IRIs of the concepts
		 * @return the concepts
		 */
		getConcepts(iris) {
			return iris.map(iri => this.getConcept(iri))
		}

		/**
		 * return the registerd concept name for the IRI
		 * @param iri the IRI of the concept
		 * @return the name of founded concept, empty string if not find
		 */
		static getConceptName(iri){
			ConceptsUtil.getConceptName(iri)
		}

		/**
		 * return the registerd concept ontology ID for the IRI
		 * @param iri the IRI of the concept
		 * @return the ontology ID of founded concept, empty string if not find
		 */
		static getOnotlogyId(iri){
			ConceptsUtil.getOnotlogyId(iri)
		}
	}

	return OntologyService
})
